/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { HomeComponent } from './app/home/home.component';

// Bootstraps the standalone Angular app. Authentication and routing
// providers are wired in app.config.ts.
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));